import { Stack, Typography } from "@mui/material"
import { colours } from "../../../StyleConstants"

type Props = {
    title: string
    clickInfo?: any
    text: string
    skinny?: boolean
    disabled?: boolean
    selected?: boolean
    handleClick?: Function
    onMouseOut?: Function
    mouseOutInfo?: number
    size?: string
    fileCount?: string
}
const Selector = ({ title, clickInfo = "", text, skinny = false, selected = false, disabled = false,
    handleClick = () => {}, onMouseOut = () => {}, mouseOutInfo = 0, size = '0 GB', fileCount = 'O files' }: Props) => {

    const getStyle = () => {
        return (disabled) ?
            {
                border: "2px solid",
                borderColor: '#AAA',
                backgroundColor: '#DDD',
            } :
            (!selected) ?
                {

                    '&:hover': {
                        backgroundColor: colours.orange.orange20,
                        border: `2px solid ${colours.orange.orange}`
                    },
                    borderRadius: "5px",
                    backgroundColor: colours.orange.orange10,

                } : {
                    border: "2px solid",
                    borderColor: colours.orange.orange,
                    backgroundColor: colours.orange.orange20
                }
    }

    

    return(
        <Stack
            padding={2}
            height="100px"
            borderRadius="5px"
            sx={{
                cursor: disabled ? 'default' : 'pointer',
                height: skinny ? "auto" : "100px",
                ...getStyle()
            }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            onClick={() => !disabled && handleClick(clickInfo)}
            onMouseOut = {() => onMouseOut(mouseOutInfo)}
        >
            <Stack flexGrow={2}>
                <Stack flexGrow={2} direction="row" justifyContent="space-between">
                    <Typography variant="body1" fontWeight="600" color={colours.midnightBlue.blue}>
                        {title}
                    </Typography>
                    {skinny && (
                        <Typography variant="body1" fontWeight="600" color={colours.midnightBlue.blue}>
                            {size}
                        </Typography>
                    )}
                </Stack>
                <Stack flexGrow={2} direction="row" justifyContent="space-between">
                    <Typography variant="body2" color={disabled? '#555' : colours.gray.gray30}>
                        {text}
                    </Typography>
                    {skinny && (
                        <Typography variant="body2" color={colours.gray.gray30}>
                            {fileCount}
                        </Typography>
                    )}
                </Stack>
            </Stack>
        </Stack>
    )
}

export default Selector